<template>
  <div :id="lead.id" class="list-box-container"
       :class="{'border-blue': lead.status_id === 9}"
       @mouseup="($_can('leads.show') ||
         $_can('leads.view-own'))"
  >
    <template v-if="leadLoading">
      <div class="lds-ellipsis px-4 py-4">
        <div />
        <div />
        <div />
      </div>
    </template>
    <template v-else>
      <router-link :to="{ name: 'LeadsEdit', params: { id: `${lead.id}`}, query: { q: `${q ? `${encodeURIComponent(q.toUpperCase())}` : ''}`}}">
        <div class="d-flex list-box-header col-12">
          <div class="pl-0 list-box-header-left col-lg-7 col-9 pr-md-5 pr-lg-5 pr-xl-5">
            <div class="pl-0 d-flex align-items-center col-lg-5 col-md-5 col-xl-5 col-12 pointer">
              <div class="list-box-status align-items-start col-lg-5 col-md-5 col-xl-5 col-12 pr-3" @mousemove="visible = true" @mouseleave="visible = false">
                <div class="pointer d-flex">
                  <span class="ref-id pr-2">
                    {{ lead.ref_id }}
                  </span>
                  <span>
                    <i
                      v-if="visible"
                      class="fa fa-copy list-box-icon pointer"
                      @click.prevent.stop="copyToClipboard(lead.ref_id, 'Successfully copied to clipboard')"
                      @mousemove="visible = true"
                    />
                  </span>
                </div>
                <template v-if="lead.status">
                  <span v-if="lead.status_id === 1"
                        :class="'btn-status btn-active'"
                  >{{ lead.status }}</span>
                  <span v-else-if="lead.status_id === 2"
                        :class="'btn-status btn-booked'"
                  >{{ lead.status }}</span>
                  <span v-else-if="lead.status_id === 3 || lead.status_id === 6"
                        :class="'btn-status btn-closed'"
                  >{{ lead.status }}</span>
                  <span v-else-if="lead.status_id === 4 || lead.status_id === 8"
                        :class="'btn-status btn-ncover'"
                  >{{ lead.status }}</span>
                  <span v-else-if="lead.status_id === 5"
                        :class="'btn-status btn-rtbook'"
                  >{{ lead.status }}</span>
                  <span v-else-if="lead.status_id === 7"
                        :class="'btn-status btn-rejected'"
                  >{{ lead.status }}</span>
                  <span v-else
                        :class="'btn-status btn-active'"
                  >{{ lead.status }}</span>
                </template>
              </div>
              <div class="claim-customer col-7 pl-3 d-none d-md-flex d-lg-flex d-xl-flex">
                {{ lead.customer.name }}
              </div>
            </div>
            <div class="d-flex align-items-center col-3 wrap pointer">
              <div class="claim-moving-company contact-info-wrap">
                {{ lead.company }}
              </div>
            </div>
            <label />
            <div class="d-flex align-items-center claim-move-date contact-info-wrap col-2 wrap pointer">
              <customTooltip :config="{ placement: 'top' }">
                <div
                  slot-scope="{ isOpen, open, close }"
                  @mouseover="open"
                  @mouseleave="close"
                >
                  <span data-trigger>
                    {{ lead.move_date }}
                  </span>
                  <div
                    v-show="isOpen"
                    data-popper
                    class="custom-tooltip"
                  >
                    <div
                      x-arrow
                      class="border-black"
                    />
                    Move date
                  </div>
                </div>
              </customTooltip>
            </div>
            <div class="d-flex align-items-center col-3 pr-4 wrap pointer">
              <div class="claim-move-date contact-info-wrap">
                {{ lead.move_size }}
              </div>
            </div>
          </div>
          <div class="list-box-header-right col-lg-5 col-3 pl-md-5 pl-lg-5 pl-xl-5">
            <label />
            <div class="d-flex align-items-center col-0 col-lg-5 wrap pointer">
              <customTooltip :config="{ placement: 'top' }">
                <div
                  slot-scope="{ isOpen, open, close }"
                  @mouseover="open"
                  @mouseleave="close"
                >
                  <div class="claim-agent" v-if="lead.cluster_user" data-trigger>
                    {{ lead.cluster_user.username }}
                  </div>
                  <div class="claim-agent" v-else data-trigger>
                    <i class="fa fa-exclamation-circle unassigned-icon" />
                    <span>
                      Unassigned
                    </span>
                  </div>
                  <div
                    v-show="isOpen"
                    data-popper
                    class="custom-tooltip"
                  >
                    <div
                      x-arrow
                      class="border-black"
                    />
                    Assignee
                  </div>
                </div>
              </customTooltip>
            </div>
            <div class="list-box-header-options justify-content-end col-12 col-lg-7">
              <div v-if="lead.status_id === 2"
                   class="claim-trucks-movers d-none d-md-flex d-lg-flex d-xl-flex align-items-center pr-4 wrap pointer"
              >
                <i class="fa fa-user list-box-icon" />
                <span class="price-value pr-2">
                  {{ lead.movers }}
                </span>
                <i class="fa fa-truck list-box-icon" />
                <span class="price-value">
                  {{ lead.trucks }}
                </span>
              </div>
              <div v-if="lead.status_id === 2" class="d-flex align-items-center price pr-md-5 pr-lg-5 pr-xl-5 wrap pointer">
                ${{ lead.price_per_hour }}
              </div>
              <div class="options pr-2 pr-md-0 pr-lg-0 pr-xl-0 pl-md-4 pl-lg-4 pl-xl-4">
                <div class="options-buttons">
                  <div class="dropdown" v-if="lead.status_id !== 3 && lead.status_id !== 2" @click.prevent>
                    <button type="button" class="btn btn-secondary add-filter" id="dropdownMenuButton"
                            data-toggle="dropdown" aria-haspopup="true"
                            aria-expanded="false"
                    />
                    <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                      <button class="dropdown-item nav-link btn" v-if="$_can('leads.assign')"
                              @click="reassignModal"
                      >
                        Reassign lead
                      </button>
                      <button class="dropdown-item nav-link btn" v-if="lead.status_id === 1 || lead.status_id === 7"
                              @click="changeStatus(lead.id, 5)"
                      >
                        Ready for booking
                      </button>
                      <button class="dropdown-item nav-link btn" v-if="lead.status_id !== 7"
                              @click="changeStatus(lead.id,7)"
                      >
                        On hold
                      </button>
                      <button class="dropdown-item nav-link btn" v-if="lead.status_id !== 3"
                              @click="changeStatus(lead.id, 3)"
                      >
                        Close lead
                      </button>
                      <button class="dropdown-item nav-link btn" v-if="lead.status_id !== 8"
                              @click="changeStatus(lead.id, 8)"
                      >
                        No availability
                      </button>
                    </div>
                  </div>
                  <button class="btn btn-secondary expand-claims d-none d-md-block d-lg-block d-xl-block" @click.prevent.stop="toggleLead(lead.id)">
                    <i class="fa fa-caret-down caret" :class="{ rotate: expanded.includes(lead.id) }" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </router-link>
      <hr :class="[expanded.includes(lead.id) ? 'w-100 divider' : 'hidden']" />
      <div class="d-flex flex-column" :class="[expanded.includes(lead.id) ? 'list-box-expanded' : 'hidden']">
        <div class="d-flex row col-12 p-0">
          <div v-if="showCustomerInfo" class="d-none d-md-flex d-lg-flex d-xl-flex flex-column justify-content-start col-lg-3 col-1 customer-info-wrap">
            <div class="contact-info mb-4 contact-info-wrap">
              <span class="claim-heading pb-3">
                Contact info
              </span>
              <span class="email">
                <i class="fa fa-at list-box-icon" />
                {{ lead.customer.email }}
              </span>
              <span class="phone">
                <i class="fa fa-phone list-box-icon" />
                {{ phoneMask.maskedPhone(lead.customer.phone) }}
              </span>
            </div>
            <div class="row py-2 mx-0 follows-buttons follows-buttons-list" v-if="$_can('leads.follow-ups.store')">
              <span
                class="mod-icon-btn-follow mod-icon-btn-incall pointer"
                @click="showCallModal = true"
              />
              <span
                class="mod-icon-btn-follow mod-icon-btn-email pointer"
                @click="showEmailModal = true"
              />
              <span
                v-if="lead.has_follow_up_number"
                class="mod-icon-btn-follow mod-icon-btn-message pointer"
                @click="showSMSModal = true"
              />
              <customTooltip
                v-else
                :config="{ placement: 'top' }"
              >
                <div
                  slot-scope="{ isOpen, open, close }"
                  @mouseover="open"
                  @mouseleave="close"
                >
                  <span class="mod-icon-btn-follow mod-icon-btn-message pointer disabled"
                        data-trigger
                  />
                  <div
                    v-show="isOpen"
                    data-popper
                    class="custom-tooltip"
                  >
                    <div
                      x-arrow
                      class="border-black"
                    />
                    Company doesn't have phone
                    <br />
                    number for sending SMS
                  </div>
                </div>
              </customTooltip>
              <span
                class="mod-icon-btn-follow mod-icon-btn-voice-call pointer"
                @click="showVoiceModal = true"
              />
            </div>
          </div>
          <div class="d-flex flex-column justify-content-start col-lg-3 col-md-3 col-xl-3 col-12">
            <span class="claim-heading">
              From - To
            </span>
            <div class="circles-wrap">
              <div class="d-flex flex-column justify-content-between mt-3">
                <div class="d-flex mb-4">
                  <i
                    class="fa fa-circle c-pickup"
                    :class="[
                      lead.addresses[0].type.name === 'Pickup'
                        ? 'c-pickup'
                        : 'c-delivery',
                      lead.addresses[0].apartment || lead.addresses[0].floor
                        ? 'fa-circle-with-apt'
                        : 'fa-circle'
                    ]"
                  />
                  <span class="d-flex flex-column address-text">
                    {{ lead.addresses[0].full_address }}
                    <div class="d-flex align-items-center pt-3">
                      <span class="apt-floor">Apt: {{ lead.addresses[0].apartment ? lead.addresses[0].apartment : '-' }}</span>
                      <span class="apt-floor pl-4">Floor: {{ lead.addresses[0].floor ? lead.addresses[0].floor : '-' }}</span>
                    </div>
                  </span>
                </div>
              </div>
              <span class="remaining-addresses" v-if="lead.addresses.length > 2">
                {{ parseInt(lead.addresses.length) - 2 }}
              </span>
              <div class="d-flex flex-column justify-content-between mt-3">
                <div class="d-flex mb-4">
                  <i
                    class="fa fa-circle c-pickup"
                    :class="[
                      lead.addresses[lead.addresses.length - 1].type.name === 'Pickup'
                        ? 'c-pickup'
                        : 'c-delivery',
                      lead.addresses[lead.addresses.length - 1].apartment || lead.addresses[lead.addresses.length - 1].floor
                        ? 'fa-circle-with-apt'
                        : 'fa-circle'
                    ]"
                  />
                  <span class="d-flex flex-column address-text">
                    {{ lead.addresses[lead.addresses.length - 1].full_address }}
                    <div class="d-flex align-items-center pt-3">
                      <span class="apt-floor">Apt: {{ lead.addresses[lead.addresses.length - 1].apartment ? lead.addresses[lead.addresses.length - 1].apartment : '-' }}</span>
                      <span class="apt-floor pl-4">Floor: {{ lead.addresses[lead.addresses.length - 1].floor ? lead.addresses[lead.addresses.length - 1].floor : '-' }}</span>
                    </div>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex flex-column justify-content-start col-lg-2 contact-info-wrap">
            <div class="list-box-info mb-4">
              <span class="claim-heading pb-3">
                Deposit
              </span>
              <span v-if="lead.deposit_unit === '$'">
                {{ lead.deposit_unit }}{{ lead.deposit_value }}
              </span>
              <span v-else>
                {{ lead.deposit_value }} {{ lead.deposit_unit }}
              </span>
            </div>
            <div class="list-box-info mb-4">
              <span class="claim-heading pb-3">
                Tags
              </span>
              <div v-if="$_can('tags.show')" class="d-flex align-items-center justify-content-start flex-wrap">
                <tag-color v-for="tag in lead.tags" :key="tag.id" :color="tag.color.name" :name="tag.name" input-class="mr-1" />
              </div>
            </div>
          </div>
          <div class="d-flex flex-column justify-content-start col-lg-2 col-md-2 col-xl-2 col-12">
            <div class="list-box-info mb-4">
              <span class="claim-heading pb-3">
                Created by
              </span>
              <span class="pb-3" v-if="lead.status_id !== 9 && lead.cluster_user">
                {{ lead.cluster_user.username }}
              </span>
              <span v-else class="pb-3">
                System
              </span>
              <span class="claim-heading pb-3">
                Arrival window
              </span>
              <span v-if="lead.arrival_window_from || lead.arrival_window_to">
                {{ lead.arrival_window_from }} - {{ lead.arrival_window_to }}
              </span>
              <span v-else>
                -
              </span>
            </div>
          </div>
          <div class="d-none d-md-flex d-lg-flex d-xl-flex flex-column justify-content-start col-lg-2 col-3">
            <div class="list-box-info mb-4">
              <span class="claim-heading pb-3 contact-info-wrap">
                Created at
              </span>
              <span class="pb-3 contact-info-wrap">
                {{ lead.created_at }}
              </span>
              <span class="claim-heading pb-3">
                Source
              </span>
              <span>
                {{ lead.source }}
              </span>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-start col-12" v-if="lead.status_id === 2">
          <div class="claim-closed col-lg-5 col-12">
            <div class="d-flex col-11 col-md-9 col-lg-9 col-xl-9 mb-2 p-0 pr-md-3 pr-lg-3 pr-xl-3 w-100 booked-lead">
              <i class="fa fa-check reopen-ico pr-2" />
              <p>This lead was booked!</p>
            </div>
            <router-link class="col-1 col-md-3 col-lg-3 col-xl-3" :to="{ path: '/jobs/edit/' + lead.job_id}" target="_blank">
              <div class="d-flex pointer justify-content-end go-to-job">
                <span class="reopen-text text-white d-none d-md-flex d-lg-flex d-xl-flex">Go to job</span>
                <i class="fa fa-arrow-right reopen-ico pl-2 text-white" />
              </div>
            </router-link>
          </div>
        </div>
        <div class="circles-wrap d-flex justify-content-start align-items-center col-12" v-if="lead.follow_ups && lead.follow_ups.length">
          <span class="follow-ups-title font-weight-bold pr-3">
            Completed follow ups:
          </span>
          <div class="follow-ups-wrapper" v-for="(followUp, index) in lead.follow_ups" :key="index">
            <div v-if="followUp.type.id === 1" class="mod-icon-follow-up mod-icon-follow-incall" />
            <div v-if="followUp.type.id === 2" class="mod-icon-follow-up mod-icon-follow-email" />
            <div v-if="followUp.type.id === 3" class="mod-icon-follow-up mod-icon-follow-voice-call" />
            <div v-if="followUp.type.id === 4" class="mod-icon-follow-up mod-icon-follow-message" />
          </div>
        </div>
      </div>

      <!--Call-->
      <template v-if="showCallModal">
        <call :lead="lead" @close="closeModal" />
      </template>

      <!--Email-->
      <template v-if="showEmailModal">
        <email :lead="lead" :list="true" @close="closeModal" />
      </template>

      <!--SMS-->
      <template v-if="showSMSModal">
        <s-m-s :lead="lead" :list="true" @close="closeModal" />
      </template>

      <!--Voice-->
      <template v-if="showVoiceModal">
        <voice :lead="lead" @close="closeModal" />
      </template>

      <!-- reassign modal -->
      <modal v-if="showReassignModal"
             @close="showReassignModal = false"
             :size="'modal-large'"
             :close-strict="true"
      >
        <div slot="header">
          <div class="row">
            <div class="col-10">
              <div>
                <h4>{{ lead.ref_id }} - Reassign lead to</h4>
              </div>
            </div>
          </div>
        </div>
        <div slot="body">
          <div class="select-wrap">
            <label>Select User</label>
            <simple-select v-model="assigneeId"
                           :options="assignees"
                           @change="clearError($event)"
            />
          </div>
          <error-field :errors="errors" field="cluster_user_id" />
        </div>
        <div slot="footer">
          <div class="row">
            <div class="col-12">
              <button type="button"
                      class="btn btn-primary pull-right"
                      @click="reassign"
              >
                Reassign
              </button>
            </div>
          </div>
        </div>
      </modal>
    </template>
  </div>
</template>
<script>
import axios from 'axios';
import toastr from 'toastr';
import moment from 'moment';
import Call from './followUps/Call';
import Email from './followUps/Email';
import SMS from './followUps/SMS';
import Voice from './followUps/Voice';
import Modal from '../Modal';
import customTooltip from '../CustomTooltip';
import PhoneMask from '../../classes/PhoneMask';
import Errors from '../../classes/Errors';
import TagColor from '../settings/Tags/TagColor';

export default {
  components: {
    TagColor,
    Call,
    Email,
    SMS,
    Voice,
    Modal,
    customTooltip,
  },
  props: {
    lead: {
      type: Object,
      default: () => {},
    },
    q: {
      type: String,
      default: () => '',
    },
    expanded: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    assignees: [],
    leadLoading: false,
    visible: false,
    showCallModal: false,
    showEmailModal: false,
    showSMSModal: false,
    showVoiceModal: false,
    showReassignModal: false,
    canSeeCustomerInfo: false,
    assigneeId: null,
    phoneMask: new PhoneMask(),
    errors: new Errors(),
  }),
  computed: {
    showCustomerInfo() {
      return this.$_can('customer-info-subco.show') || this.canSeeCustomerInfo;
    },
  },
  watch: {
    lead() {
      this.checkDate();
    },
  },
  mounted() {
    this.checkDate();
  },
  methods: {
    getLead(leadMessage) {
      axios
        .get(`/leads/list/${this.lead.id}`)
        .then(res => {
          this.lead = res.data.data;
          if (leadMessage) toastr.success(leadMessage);
        })
        .finally(() => {
          this.leadLoading = false;
        });
    },
    reassignModal() {
      axios
        .get(`clusters/users/sales`)
        .then(res => {
          res.data.data.forEach(assignee => {
            assignee.name = `${assignee.first_name} ${assignee.last_name}`;
          });
          this.assignees = res.data.data;
        })
        .then(() => {
          this.showReassignModal = true;
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    reassign() {
      this.leadLoading = true;
      axios
        .patch(`leads/${this.lead.id}/cluster-user`, { cluster_user_id: this.assigneeId })
        .then(() => {
          this.getLead('Successfully reassigned lead');
          this.showReassignModal = false;
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    changeStatus(id, statusId) {
      this.leadLoading = true;
      axios
        .put(`leads/${id}/status`, { status_id: statusId })
        .then(() => {
          this.getLead('Successfully updated status');
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    copyToClipboard(refId, message) {
      this.$copyText(refId).then(() => toastr.success(message, '', { timeOut: 1000 }));
    },
    toggleLead(id) {
      this.$emit('expanded', id);
    },
    closeModal() {
      this.showCallModal = false;
      this.showEmailModal = false;
      this.showSMSModal = false;
      this.showVoiceModal = false;
    },
    clearError(event) {
      this.errors.clear(event.target.name);
    },
    viewInNewTab(event, id) {
      this.$emit('setFiltersSaved');
      const routeData = this.$router.resolve({
        path: `/leads/edit/${id}`,
        query: { q: this.q.toUpperCase() },
      });
      window.open(routeData.href, '_blank');
    },
    view(event, id) {
      this.$router.push(
        `/leads/edit/${id}${this.q ? `?q=${encodeURIComponent(this.q.toUpperCase())}` : ''}`,
      );
    },
    checkDate() {
      if (
        moment(this.lead.move_date, 'MM-DD-YYYY h:m a').format('YYYY-MM-DD') <=
        moment()
          .subtract('1', 'd')
          .format('YYYY-MM-DD')
      ) {
        this.canSeeCustomerInfo = true;
      } else if (
        moment(this.lead.move_date, 'MM-DD-YYYY h:m a').format('YYYY-MM-DD') ===
        moment().format('YYYY-MM-DD')
      ) {
        this.canSeeCustomerInfo = true;
      } else if (
        moment(this.lead.move_date, 'MM-DD-YYYY h:m a').format('YYYY-MM-DD') ===
        moment()
          .add('1', 'd')
          .format('YYYY-MM-DD')
      ) {
        this.canSeeCustomerInfo = true;
      } else {
        this.canSeeCustomerInfo = false;
      }
    },
    // formatTime(time) {
    //   return moment(time).format('hh:mm A');
    // },
  },
};
</script>
<style lang="scss" scoped>
a {
  color: inherit !important;
  width: 100%;
  text-decoration: none;
}
a:hover {
  color: inherit !important;
  text-decoration: none !important;
}
.lds-ellipsis {
  display: flex;
  justify-content: center;
  height: 45px;
  padding-top: 11px;
}

.lds-ellipsis div {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin: 10px !important;
  background: #e3e3e3;
  animation: loader 0.6s infinite alternate;
}

.lds-ellipsis > div:nth-child(2) {
  animation-delay: 0.2s;
}

.lds-ellipsis > div:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes loader {
  to {
    opacity: 0.1;
    transform: translate(0, -20px);
    background: #e0e5ea;
  }
}
.go-to-job {
  padding-top: 4px;
}
.claim-closed {
  background-color: #2962ff;
  display: flex;
  color: #fff;
  border-radius: 4px;
  padding: 14px;
  height: 52px;
}
.list-box-status {
  align-items: normal;
}
.reopen-ico {
  line-height: inherit;
}
.expand-claims {
  height: 40px;
  width: 40px;
  margin-left: 7px;
}
.claim-closed {
  justify-content: space-between;
}
.fa-circle {
  position: relative;

  &:after {
    content: '';
    top: 13px;
    left: 5.5px;
    position: absolute;
    width: 1px;
    min-height: 70px;
    background-color: grey;
  }
}
.circles-wrap > div:last-child .fa-circle:after {
  display: none;
}
.address-text {
  line-height: 1;
  font-size: 13px;
  padding-left: 5px;
}
.apt-floor {
  font-size: 11px;
  color: #979797;
}
.fa-circle-with-apt {
  position: relative;

  &:after {
    content: '';
    top: 13px;
    left: 5.5px;
    position: absolute;
    width: 1px;
    min-height: 84px;
    background-color: grey;
  }
}
.remaining-addresses {
  background: white;
  position: absolute;
  top: 78px;
  left: 13px;
  text-align: center;
  height: 23px;
  border-radius: 3px;
  width: 16px;
  border: 1px solid grey;
}
.wrap {
  min-height: 45px;
}
.follow-ups-wrapper {
  padding: 10px 10px 10px 0;

  & > div {
    position: relative;

    &:after {
      content: '';
      left: 33px;
      top: 3px;
      position: absolute;
      width: 1px;
      transform: rotate(90deg);
      min-height: 20px;
      background-color: grey;
    }
  }
}
.circles-wrap > div:last-child .mod-icon-follow-up:after {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/leads/LeadsBlock.vue